import React, {useState,useContext} from 'react'
import CartContext from './CartContext'
import {firestore} from '../firebaseConfig'
import firebase from 'firebase/app';
import {useHistory} from 'react-router-dom'
import CheckoutForm from './CheckoutForm'
import axios from 'axios'

const BuyCart = () => {

    const { cart, total, clearItem, setCart } = useContext(CartContext)
    const [vaciar, setVaciar] = useState(false)
    const [formulario, setFormulario] = useState("mostrar")
    const [nombre, setNombre] = useState("")
    const [apellido, setApellido] = useState("")
    const [email, setEmail] = useState("")
    const [confirmacion, setConfirmacion] = useState("")
    const [telefono,setTelefono] = useState("")
    const [bloqueo,setBloqueo] = useState(true)
    const [compra, setCompra] = useState("")
    const [alerta, setAlerta] = useState("")

    const vaciarCarrito = () => {
        setVaciar(true)
    }
    const cancelar = () => {
        setVaciar(false)
    }

    const obtenerNombre = (e) => {
        setNombre(e.target.value)
        console.log(nombre)
    }
    const obtenerApellido = (e) => {
        setApellido(e.target.value)
        console.log(apellido)
    }

    const obtenerEmail = (e) => {
        setEmail(e.target.value)
        console.log(email)
    }
    const confirmarEmail = (e) => {
        console.log(confirmacion)
        setConfirmacion(e.target.value)
            if (e.target.value === email) {
                console.log("el correo coincide")
                setBloqueo(false)
                setAlerta("Perfecto!!!")
            } else {
                console.log("el correo no coincide")
                setBloqueo(true)
                setAlerta("Ups... Tu correo no coincide")
            }
    }
    
    
    const obtenerTelefono = (e) => {
        setTelefono(e.target.value)
        console.log(telefono)
    }

    let history = useHistory()

    const enviarOrden = (e) => {
      
        e.stopPropagation()
        e.preventDefault()

        // Envío los datos al servidor para que envíe los datos a Hubspot
        console.log(cart)
        const productos_hs = {}
        const producto_hs = {
            productos: {
                value: cart.map((producto_hs) => 
                producto_hs.item.id_interno
                ),
            }
        }

        console.log(producto_hs)

        const buyer = { 
            firstname: nombre, 
            email: email, 
            phone: telefono,
        };

        axios.post('http://localhost:3001/hs', buyer)
        .then(() => console.log('Contacto creado'))
        .catch(err => {
          console.error(err);
        });

        console.log("click " + nombre + email + telefono)
    
        // Envío la orden a la collección de firebase
        
        const db = firestore
        const orders = db.collection('ordenes')

        const order = {
            buyer: { name: nombre, email: email, phone: telefono},
            items: cart,
            date: firebase.firestore.Timestamp.fromDate(new Date()),
            total: total,
            estado: "pendiente",
        }
        orders.add(order)
        .then(({ id }) => {
            setCompra("El id de tu compra es: " + id)
            console.log("Orden enviada con éxito")
            setNombre("")
            setTelefono("")
            setEmail("")
            setConfirmacion("")
            setFormulario("ocultar")
            setCart([])
            console.log(cart)
            
            // Limpio el carrito
            clearItem()
            
            // Luego redireccionar a la página de gracias o al Home
            history.push("/")



            
        })
        .catch((error) => console.log(error))
        
        
    }
    
    



    return (
        <div className="intro">
            <h1>Carrito</h1>
            <div className="container_carrito">
                <div className={"item_carrito " + formulario}>
                    <div className="barrer_izq">
                                               
                    {/*<form className={formulario} method="post" action="http://localhost:3000/hs" enctype = "form-data">*/}
                    <form className={formulario} onsubmit={enviarOrden} enctype = "form-data">
                        <fieldset className="fieldset_2">
                            <div>
                                <label>Nombre</label>
                                <input onChange={obtenerNombre} type="text" value={nombre} required name="firstname"/>
                            </div>
                            <div>
                                <label>Apellido</label>
                                <input onChange={obtenerApellido} type="text" value={apellido} name="lastname" required/>
                            </div>
                        </fieldset>
                        <fieldset className="fieldset_2">
                            <div>
                                <label>Correo</label>
                                <input onChange={obtenerEmail}type="email" value={email} name="email" required/>
                            </div>
                            <div>
                                <label>Confirme su correo</label>
                                <input onChange={confirmarEmail}type="email" value={confirmacion} required/>
                            </div>
                            <small>{alerta}</small>
                        </fieldset>
                        <fieldset className="fieldset_1">
                            <div>
                                <label>Teléfono</label>
                                <input onChange={obtenerTelefono}type="tel" value={telefono} name="phone" required />
                            </div>
                        </fieldset>
                        <fieldset className="fieldset_1">
                            <div>
                                <label>¿Algún otro comentario?</label>
                                <textarea></textarea>
                            </div>
                            <div>
                                <label>¿Quieres suscribirte a nuestro Newsletter?</label>
                                <div className="input_suscripcion">
                                    <input className="toggle-state" type="checkbox" name="check" value="check" checked/>
                                    <label>Sí, quiero suscribirme.</label>
                                </div>
                            </div>
                        </fieldset>
                        <div>
                            <input type="submit" value="Enviar pedido" onClick={enviarOrden} disabled={bloqueo}/>
                        </div>  
                    </form>
                        {/* 
                        <CheckoutForm/>
                        */}

                    <div className={!formulario}>
                        <p>{compra}</p>
                    </div>
                    </div>
                </div>
                { cart.length > 0 ? (  
                    <div className={"contenedor_detalles_carrito " + formulario}>
                        <div className="detalles_carrito barrer_izq">
                            <ul className="item_carrito_total">
                                    {cart.map((producto) =>{
                                        return (
                                            <li key={producto.id} className="aparecer_top">
                                                <p>{producto.item.title}</p>
                                                <span className="separador"></span>
                                                <p>x {producto.contador}</p>
                                            </li>
                                            )
                                        })
                                    }
                            </ul>
                            <div className="finalizar_carrito">
                                <span>Total a Pagar: ${total}</span>
                                <div className="botones_carrito">
                                    <button className="btn_vaciar_carrito" onClick={() => vaciarCarrito()}>Cancelar Compra</button>
                                </div>
                            </div>
                            <div className={"popup vaciar " + vaciar}>
                                <div>
                                        <h3>¿Seguro deseas cancelar esta compra?</h3>
                                    <div>
                                        <button className="btn_vaciar_carrito" onClick={() => clearItem()}>Cancelar Compra</button>
                                        <button className="btn_cancelar" onClick={() => cancelar()}>Seguir comprando</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    ) : (
                        <>
                        </>
                        )
                    }
            </div>
        </div>
    )
}

export default BuyCart
